module.exports = __webpack_public_path__ + "./images/d5e9374fa90a0c5ce224355b705c2b81.png";